import { createSlice } from '@reduxjs/toolkit'
import { getOfficeList } from '../Thunk/officeThunk'

const initialState = {
    officeList:[],
}

export const officeSlice = createSlice({
        name:'officeThunk',
        initialState,
        reducers:{ 

        
        },

        extraReducers:(builder)=>{
        
            builder.addCase(getOfficeList.fulfilled,(state,action)=>{
                state.officeList = action.payload
            })

        }
})


export const {storeEditCustomerDetails} = officeSlice.actions
export default officeSlice.reducer